import { FF_IMMEDIATE_NURSE_CONSULTATION_VARIANTS } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { useMemo } from 'react';

export enum ImmediateNurseConsultationVariant {
  CONTROL = 'control',
  VARIANT = 'variant',
  VARIANT_1 = 'variant-1',
  VARIANT_2 = 'variant-2',
  VARIANT_AMAZON_CONNECT_INITIATED_INC = 'variant-amazon-connect-initiated-inc'
}

export const useImmediateNurseConsultVariant = () => {
  const { flags } = useFeatureFlags();
  return useMemo(() => {
    const flagValue = flags[FF_IMMEDIATE_NURSE_CONSULTATION_VARIANTS]?.toLowerCase();
    return Object.values(ImmediateNurseConsultationVariant).includes(flagValue)
      ? (flagValue as ImmediateNurseConsultationVariant)
      : ImmediateNurseConsultationVariant.CONTROL;
  }, [flags]);
};
